<template>
  <sort-control :condition="data" :isload="isload" />
</template>

<script>
import sortControl from '@global/components/productList_vue/sort';

export default {
  name: 'SortApp',
  components: {
    sortControl,
  },
  props: ['data', 'isload'],
};
</script>

<style></style>
